import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { EntitlementProvider } from "./core/entitlement";
import ReferralCapture from "./core/ReferralCapture";
import StartScreen from "./screens/StartScreen";
import Onboarding from "./screens/Onboarding";
import ChildHome from "./screens/ChildHome";
import WorldPath from "./screens/WorldPath";
import GameSession from "./screens/GameSession";
import NextAdventures from "./screens/NextAdventures";
import PikoGarden from "./screens/PikoGarden";
import StickerBook from "./screens/StickerBook";
import ParentGate from "./screens/ParentGate";
import ParentDashboard from "./screens/ParentDashboard";
import AdminAffiliateDashboard from "./screens/AdminAffiliateDashboard";
import { PaymentSuccess, PaymentCancel, FpxResult } from "./screens/PaymentResult";

// Auto-advance navigates from /game/a to /game/b. Without a key React Router
// keeps the SAME GameSession instance and only swaps the param, so its
// `useState('greet')` never re-initialises and the countdown effect never
// re-runs — the screen stays frozen on the previous game's reward phase.
// Keying by gameId forces a real remount, which is what every phase assumes.
function GameSessionRoute() {
  const { gameId } = useParams();
  return <GameSession key={gameId} />;
}

function App() {
  return (
    <EntitlementProvider>
      <BrowserRouter>
        <ReferralCapture />
        <Routes>
          <Route path="/" element={<StartScreen />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/home" element={<ChildHome />} />
          <Route path="/world/:worldId" element={<WorldPath />} />
          <Route path="/game/:gameId" element={<GameSessionRoute />} />
          <Route path="/play/:worldId" element={<Navigate to="/home" replace />} />
          <Route path="/next-adventures" element={<NextAdventures />} />
          <Route path="/garden" element={<PikoGarden />} />
          <Route path="/stickers" element={<StickerBook />} />
          <Route path="/parent-gate" element={<ParentGate />} />
          <Route path="/parent" element={<ParentDashboard />} />
          <Route path="/admin/affiliate" element={<AdminAffiliateDashboard />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/payment/fpx-result" element={<FpxResult />} />
          <Route path="*" element={<StartScreen />} />
        </Routes>
      </BrowserRouter>
    </EntitlementProvider>
  );
}

export default App;
